export const dataTestId = 'interview-guide-form';

export const ENABLING_DISCLAIMER_SCORES = (
  <>
    When this setting is enabled, assessment scores will be displayed in the
    Interview Guide for candidates who completed an assessment.
  </>
);

export const DISABLING_DISCLAIMER_SCORES = (
  <>
    When this setting is disabled, assessment scores will be hidden in the
    Interview Guide for candidates, even if they completed an assessment.
  </>
);
